<template>
  <!-- 购买弹层 数量等 -->
  <div class="order-popup">
    <van-popup v-model="show2" position="bottom">
      <div class="order-wrap fs2">
        <div class="flex-between title">
          <div>创建订单</div>
          <div class="colorG" @click="showCoupons=true">
            <span v-if="CouponList.length">有{{CouponList.length}}张可用优惠券</span>
            <span v-else>选择优惠券</span>
          </div>
        </div>
        <div class="flex-between item">
          <div class="flex-start">
            <div class="maxwidth">{{orderTitle}}</div>
          </div>
          <div class="flex-start">
            <!-- 私教课显示加、减按钮，默认课时10 -->
            <div class="jian flex-center" v-if="num > 1 && targetType=='clubPtCourse'" @click="deleteNum">
              <span class="iconfont">&#xeef8;</span>
            </div>
            <span>x{{num}}</span>
            <div class="jia flex-center" v-if="targetType=='clubPtCourse'" @click="num++">
              <span class="iconfont">&#xef31;</span>
            </div>
          </div>
        </div>
        <div class="colorG item flex-end" v-if="price">¥{{(price*num).toFixed(2)}}</div>
        <div class="flex-between item" v-if="couponInfo.id">
          <div class="flex-center">
            <div class="delete flex-center">
              <span class="iconfont" @click="deleteCoupon">&#xeef8;</span>
            </div>
            <span>优惠券</span>
          </div>
          <div class="colorRed">{{couponNum}}</div>
        </div>       
        <div class="pay-btn flex-center" @click="toCreateOrder">
          <span>¥{{realPrice > 0 ? realPrice : 0}}&nbsp;</span>
          <span v-if="realPrice > 0">立即支付</span>
          <span v-else>确认</span>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showCoupons" position="top" :overlay="true" class="coupons">
      <choose-coupon :targetType="targetType" :targetId="targetId" :couponList="CouponList" @confirm="onConfirm" @changeCoupon="changeCoupon"></choose-coupon>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from 'vant';
import Func from "@/assets/scripts/func";
import query from 'query-string';
import ChooseCoupon from '@/components/chooseCoupon';
Vue.use(Toast)
export default {
  // 默认的model配置，如有需要可 进行修改 打开注释
  // model: {
  //   prop: 'value',
  //   event: 'input'
  // },  
  components: {
    ChooseCoupon
  },
  props: {
    value: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    targetId: {},
    targetType: String,
    verificationMethod: String,
    reservedTime: {},
    clubId: {},
    // 支付方式
    payment: String,
    // 课程订单或者会员订单 的推广码
    price: {
        // type: Number,
      default:'',
      required: true
    },
    orderTitle: {  //购买内容title
      type: String,
      default: () => {
        return '课时'
      }
    },
    buyType: String,
    unitType: String,
    redirect: String
  },
  data() {
    return {
      show2: false,
      showCoupons: false,  //优惠券弹层
      couponInfo: {},
      num: 1,  //默认购买数量
      ableCouponList: [],
    }
  },
  created() {
    //购买数量
    if(this.targetType == 'clubPtCourse'){
      //私教课默认10课时
      this.num = 10
    }else{
      this.num = 1
    }
  },
  watch: {
    value(val) {
      this.show2 = val;
    },
    show2(val) {
      if (!val) {
        this.$emit('input', false);
        this.showCoupons = false;
      } else {
        if (!this.targetType || !this.targetId) {
          this.$toast('订单有误');
        } else {
          this.getCoupons();
        }
      }
    }
  },
  computed: {
    // num:{
    //   //购买数量
    //   get:function(){
    //     console.log('get:')
    //       //购买数量
    //       if(this.targetType == 'clubPtCourse'){
    //         //私教课默认10课时
    //         return 10
    //       }else{
    //         return 1
    //       }
    //   },
    //   set:function(newval){
    //     console.log(newval)
    //     // return newval
    //   }      
    // },
    couponNum() {
      let P;
      if (this.couponInfo.id) {
        if (this.couponInfo.type.indexOf('minus') > -1) {
          P = '¥' + this.couponInfo.rate;
        } else if (this.couponInfo.type.indexOf('discount') > -1) {
          P = this.couponInfo.rate + '折';
        } else {
          P = '该优惠券不能识别';
        }
      }
      return P;
    },
    realPrice() {
      //最终价格
      let P;
      let price = this.price * this.num
      if (this.couponInfo.id) {
        // console.log('hava coupon:')
        if (this.couponInfo.type.indexOf('minus') > -1) {
          P = (price - this.couponInfo.rate).toFixed(2)
        } else if (this.couponInfo.type.indexOf('discount') > -1) {
          P = (price * this.couponInfo.rate / 10).toFixed(2);
        } else {
          P = price.toFixed(2)
        }
      } else {
        // console.log('no coupon:')
        P = price.toFixed(2)
      }
      return P;
    },
    CouponList() {
      //筛选满足条件的优惠券
      return this.ableCouponList.filter(item => item.type.indexOf('amount') === -1 || (item.amount <= this.price * this.num))
    }
  },
  methods: {
    deleteNum() {
      //减法
      this.num--;
      if (!!this.couponInfo.type && this.couponInfo.type.indexOf('amount') !== -1) {
        if (this.price * this.num < this.couponInfo.amount) {
          this.$toast(`未满${this.couponInfo.amount}，此优惠券不可用`)
          this.couponInfo = {};
        }
      }
    },
    deleteCoupon() {
      //删除优惠券
      this.couponInfo = {};
    },
    changeCoupon() {
      this.getCoupons()
    },
    onConfirm(data) {
      this.couponInfo = data;
      console.log(data);
      this.showCoupons = false
    },
    toCreateOrder() {
      if (this.realPrice < 0) {
        this.$dialog.confirm({
          title: '提示',
          message: '你所选择的优惠券金额大于需要支付的金额，如使用，超出部分将作废！确认使用该优惠券吗？',
          className: 'myDialogStyle'
        }).then(() => {
          this._createdOrder();
        }).catch(() => {
          // on cancel
        })
      } else {
        this._createdOrder();
      }
    },
    _createdOrder() {
      if (!Func.isSetCookie('_ibl')) {
        location.href = `${location.origin}/m/login?redirect=${encodeURIComponent(location.href)}`
        return
      }
      // let num = null;
      // if (this.targetType == 'vip') {
      //   num = this.num;
      // }

      //下单
      this.$http.post('order/create',{
        targetId:this.targetId,
        targetType:this.targetType,
        couponCode:this.couponInfo.code,
        payment:this.payment,
        num:this.num
      }).then(res => {
        console.log(res)
        this.order = res.data.value
        if(!res.data.code){
          if (this.order.status == 'paid') {
            return location.reload();
          }
          this.show2 = false;
          let domain = location.origin
          location.href = `${domain}/m/pay_page?orderId=${this.order.id}&sn=${this.order.sn}&redirect=${encodeURIComponent(domain + '/venue/#/orderview/' + this.order.id +'/'+ this.targetType)}`;
        }else{
          Toast.fail(res.data.message)
        }
      })      
    },
    getCoupons() {
      //获取优惠券
      this.$http.post('coupon/getUserCoupons', {
        targetId: this.targetId,
        targetType: this.targetType,
      }).then(res => {
        console.log(res)
        if (!res.data.code) {
          let list = res.data.value.ok || [];
          this.ableCouponList = list;
        } else {
          // Toast.fail(res.data.message)
        }
      })
    }
  },
  mounted() {
    this.p_code = this.$route.query.p_code || null;
  },
}
</script>

<style lang="less" scoped>
.order-popup {
  color: #666;
}
.order-popup .colorG {
    color: #56D176;
    font-weight: 300;
}
.order-popup .order-wrap .title {
    border-bottom: .01rem solid #ccc;
    padding: .15rem;
}
.order-popup .order-wrap .item {
    padding: .3rem .15rem;
    padding-bottom: 0;
}
.order-popup .order-wrap .item .delete {
      display: inline-block;
      width: .18rem;
      height: .18rem;
      border-radius: 50%;
      background: #fff;
      color: #EC284D;
      border: .01rem solid #EC284D;
      margin-right: .05rem;
}
.order-popup .order-wrap .colorRed {
    color: #EC284D
}
.order-popup .order-wrap .item .maxwidth {
      display: inline-block;
      max-width: 2.3rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
}
.order-popup .order-wrap .item .jian {
      width: .2rem;
      height: .2rem;
      border-radius: 50%;
      background: #fff;
      color: #56D176;
      border: .01rem solid #56D176;
      margin-right: .05rem;
}
.order-popup .order-wrap .item .jia {
      width: .2rem;
      height: .2rem;
      border-radius: 50%;
      background: #56D176;
      color: #fff;
      border: .01rem solid #fff;
      margin-left: .05rem;
}
.order-popup .order-wrap .pay-btn {
    width: 100%;
    height: .5rem;
    background: #45AF60;
    color: #fff;
    margin-top: .3rem;
    font-size: .18rem;
}
.order-popup .coupons {
    width: 101%;
    height: 73%;
    background: #f1f1f1;
}
</style>



// WEBPACK FOOTER //
// src/components/order.vue